import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Permission } from 'src/app/models/permission.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-top-list',
  templateUrl: './top-list.component.html',
  styleUrls: ['./top-list.component.sass'],
  host: {
    style: `
      position: relative;
    `
  }
})
export class TopListComponent implements OnInit {
  permission: Permission;
  tabs = [
    {
      label: 'Customer List'
    },
    {
      label: 'Suspend User List'
    }
  ];
  tabSelect: any;
  constructor(private appService: AppService, public readonly router: Router) {
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {
    this.tabSelect = this.tabs[0]
  }

  onChangeTab(tab): void {
    this.tabSelect = tab;
  }
}
